// extracted by mini-css-extract-plugin
export default {"content":"g__content--EGQt6"};